module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_9005.65d29d04.png";